/**
 * @file Core brand identity — name, tagline, domain, social handles,
 *       and the launch-state flag.
 * @module @labcraft/ui/identity/brand
 *
 * Everything in this file is content (not visual) — safe to import
 * from anywhere without dragging in styling concerns.
 */

export const BRAND = {
  name: 'LabCraft',
  tagline: 'Systems mastery, hands-on.',
  domain: 'labcraft.dev',
} as const

export const HANDLES = {
  website: 'labcraft.dev',
  github: 'labcraftdev',
  x: 'labcraftdev',
  bluesky: 'labcraft.dev',
  youtube: 'labcraftdev',
  reddit: 'labcraftdev',
  linkedin: 'labcraftdev',
} as const

/**
 * Launch state. `false` means LabCraft is pre-launch — the app nav
 * renders the "Beta" pill and the footer/title append "· Beta" to the
 * copyright line. Flip to `true` to ship publicly.
 */
export const LAUNCHED: boolean = false
